document.addEventListener("click", e => {
  if(e.target && e.target.matches(".js-open-video-modal")) {
    e.preventDefault();

    const $videoModal = document.querySelector(".js-video-modal");

    $videoModal.classList.add("modal--active");
  }
});
